import { PositionsPriceRangesType } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard/CreateShiftCard.types';
import { castStringToInteger } from 'utils';

export const getPositionDetails = ({
  positionsPriceRanges,
  position_id,
}: {
  positionsPriceRanges: PositionsPriceRangesType;
  position_id: string[];
}) => {
  const positionID = castStringToInteger(position_id[0]);
  if (positionsPriceRanges && positionsPriceRanges[positionID]) {
    const positionDetails = positionsPriceRanges[positionID];
    const { name, marketplacePriceRange, openShiftPolicy } = positionDetails;
    const min_rate = marketplacePriceRange?.min;
    const max_rate = marketplacePriceRange?.max;
    return {
      name,
      min_rate,
      max_rate,
      openShiftPolicy,
    };
  }
};
